module.exports = __webpack_public_path__ + "img/41.9b1e5fd0.png";